import React, { useRef } from "react"
import tw, { styled, css } from "twin.macro"
import Flickity from "react-flickity-component"
import "flickity/dist/flickity.min.css"
// import { ReactComponent as Caret } from "../../assets/dashboard/caret.svg"

const Wrapper = styled.div(() => [
  css`
    .flickity-page-dots .dot {
      ${tw`bg-black opacity-100 p-1 m-2 tablet-lg:(p-1.5 m-2.5)`}
    }
    .flickity-page-dots .dot.is-selected {
      ${tw`bg-purple`}
    }
    .flickity-button {
      ${tw`hidden`}
    }
  `,
])
interface CarouselProps {
  children: JSX.Element[]
  title?: string
  groupCells?: number
  cellAlign?: string
}

export const Carousel = ({ children, title, groupCells, cellAlign }: CarouselProps) => {
  const flickityRef = useRef<Flickity>()

  const flickityOptions = {
    draggable: true,
    groupCells: groupCells ?? "true",
    cellAlign: cellAlign ?? "center",
    contain: true,
    wrapAround: true,
    // prevNextButtons: true,
    // autoPlay: 6000,
  }

  return (
    <Wrapper>
      <div tw="flex items-center justify-between" data-testid={title}>
        {title && <h3 tw="title-3 w-full text-center tablet-lg:(title-2 w-auto text-left)">{title}</h3>}
        {/* <span>
          <Caret
            tw="cursor-pointer mx-2.5 hidden tablet-lg:inline"
            onClick={() => flickityRef.current && flickityRef.current.previous()}
          />
          <Caret
            tw="cursor-pointer mx-2.5 rotate-180 hidden tablet-lg:inline"
            onClick={() => flickityRef.current && flickityRef.current.next()}
          />
        </span> */}
      </div>
      <Flickity
        flickityRef={(ref) => (flickityRef.current = ref)}
        options={flickityOptions}
        disableImagesLoaded={false}
        reloadOnUpdate
        static
      >
        {children}
      </Flickity>
    </Wrapper>
  )
}
